import { booleanAttribute, Component, input } from '@angular/core';

/**
 * The "Total" tile shown on the billing-history cards: an uppercase "Total"
 * label over the grand-total hours, styled with the brand accent. Shared by the
 * resource and matter billing cards so the two stay in lockstep.
 *
 * The host element is the tile box; parents own its layout (a grid cell on the
 * resource card, a stretched right-hand column in the matter card's summary row).
 */
@Component({
  selector: 'app-billing-total-tile',
  standalone: true,
  templateUrl: './billing-total-tile.component.html',
  styleUrls: ['./billing-total-tile.component.scss'],
  host: {
    '[class.is-emphasized]': 'emphasized()',
  },
})
export class BillingTotalTileComponent {
  /** Formatted grand total (e.g. "173.5", or an en dash when zero). */
  readonly value = input<string>('');
  /** Render a skeleton placeholder instead of the value. */
  readonly loading = input(false);
  /** Draw the emphasis outline (accent border + shadow). */
  readonly emphasized = input(false, { transform: booleanAttribute });
}
